import { FLOATING_TOOL_PIPES_MOVED, APPTOOLBAR_RESET_APP_STATE } from "../lib/types";

const initialState = {
  x: 0,
  y: 0
};

export default (state = initialState, action) => {
  /* discriminate the action type */
  switch (action.type) {
    case FLOATING_TOOL_PIPES_MOVED:
      return {
        ...state,
        x: action.payload.x,
        y: action.payload.y
      };
    case APPTOOLBAR_RESET_APP_STATE:
      return initialState;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/floating-tool-pipes-reducer.js